<template>
  <div class="mini-tab-content">
    <div class="interc-toolbar">
      <span class="interc-toolbar__title">
        <feather-icon
          icon="FlagIcon"
          size="13"
          class="mr-25 text-success"
        />
        {{ involvedOutcomes.length ? involvedOutcomes.length + ' desfecho(s)' : 'Nenhum desfecho' }}
      </span>
      <button
        v-if="!activeOutcome && $hasAbility('regulacao.gerenciar')"
        class="btn btn-sm btn-success"
        @click="openOutcomeModal"
      >
        <feather-icon
          icon="PlusIcon"
          size="13"
          class="mr-25"
        />
        Registrar
      </button>
    </div>

    <div
      v-if="!involvedOutcomes.length"
      class="interc-empty"
    >
      <feather-icon
        icon="FlagIcon"
        size="26"
      />
      <p>Nenhum desfecho registrado.</p>
    </div>

    <div
      v-if="involvedOutcomes.length"
      class="interc-list"
    >
      <div
        v-for="oc in involvedOutcomes"
        :key="oc.id"
        :class="['outcome-item', { 'outcome-item--cancelled': oc.cancelled_at }]"
      >
        <div class="interc-item__top">
          <div class="outcome-item__badge">
            <feather-icon
              :icon="oc.cancelled_at ? 'XCircleIcon' : 'CheckCircleIcon'"
              size="11"
              class="mr-25"
            />
            {{ oc.outcome ? oc.outcome.name : '—' }}
          </div>
          <button
            v-if="!oc.cancelled_at && $hasAbility('regulacao.gerenciar')"
            class="interc-item__del"
            title="Cancelar desfecho"
            @click="cancelOutcome(oc.id)"
          >
            <feather-icon
              icon="Trash2Icon"
              size="13"
            />
          </button>
        </div>
        <p
          v-if="oc.observation"
          class="interc-item__desc"
        >
          {{ oc.observation }}
        </p>
        <div class="interc-item__meta">
          <feather-icon
            icon="UserIcon"
            size="11"
          />
          <span>{{ oc.registered_by ? oc.registered_by.name : '—' }}</span>
          <span class="interc-item__dot" />
          <feather-icon
            icon="ClockIcon"
            size="11"
          />
          <span>{{ oc.created_at | formatDate }}</span>
        </div>
        <div
          v-if="oc.cancelled_at"
          class="interc-item__cancelled-row"
        >
          <feather-icon
            icon="XCircleIcon"
            size="11"
            class="mr-25"
          />
          Cancelado por
          <strong>{{ oc.cancelled_by ? oc.cancelled_by.name : '—' }}</strong>
          · {{ oc.cancelled_at | formatDate }}
        </div>
      </div>
    </div>

    <b-modal
      v-model="showOutcomeModal"
      title="Registrar Desfecho"
      size="md"
      centered
      no-close-on-backdrop
      @hidden="newOutcome = { outcome_id: null, observation: '' }"
    >
      <div
        v-if="loadingOutcomesCatalog"
        class="interc-loading"
      >
        <b-spinner
          small
          variant="success"
        />
        <span>Carregando...</span>
      </div>
      <template v-else>
        <div class="form-group mb-2">
          <label class="interc-label"><span class="required">*</span> Desfecho</label>
          <v-select
            v-model="newOutcome.outcome_id"
            :options="outcomesCatalog"
            :reduce="(o) => o.id"
            label="name"
            placeholder="Selecione o desfecho..."
            class="vselect"
          />
        </div>
        <div class="form-group mb-0">
          <label class="interc-label">Observação</label>
          <textarea
            v-model="newOutcome.observation"
            class="form-control"
            rows="3"
            placeholder="Observação opcional..."
            maxlength="2000"
          />
        </div>
      </template>

      <template #modal-footer>
        <button
          class="btn btn-sm btn-outline-secondary mr-1"
          @click="showOutcomeModal = false"
        >
          Fechar
        </button>
        <button
          class="btn btn-sm btn-success"
          :disabled="savingOutcome || !newOutcome.outcome_id"
          @click="saveOutcome"
        >
          <b-spinner
            v-if="savingOutcome"
            small
            class="mr-25"
          />
          <feather-icon
            v-else
            icon="CheckCircleIcon"
            size="13"
            class="mr-25"
          />
          Registrar
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import involvedPanelMixin from './involvedPanelMixin'

export default {
  name: 'OutcomePanel',
  mixins: [involvedPanelMixin],
  props: {
    initialOutcomes: { type: Array, default: () => [] },
  },
  data() {
    return {
      involvedOutcomes: [...(this.initialOutcomes || [])],
      outcomesCatalog: [],
      loadingOutcomesCatalog: false,
      savingOutcome: false,
      showOutcomeModal: false,
      newOutcome: { outcome_id: null, observation: '' },
    }
  },
  computed: {
    activeOutcome() {
      return this.involvedOutcomes.find(o => !o.cancelled_at) || null
    },
  },
  methods: {
    openOutcomeModal() {
      this.showOutcomeModal = true
      this.loadOutcomesCatalog()
    },
    loadOutcomesCatalog() {
      this.loadingOutcomesCatalog = true
      let url = `${this.$store.state.api}outcomes/for-context?context=Envolvido`
      if (this.disciplineId) url += `&discipline_id=${this.disciplineId}`
      this.$http
        .get(url)
        .then(r => { this.outcomesCatalog = r.data.data || [] })
        .catch(() => { this.$message('Erro', 'Não foi possível carregar os desfechos.', 'error') })
        .finally(() => { this.loadingOutcomesCatalog = false })
    },
    async saveOutcome() {
      this.savingOutcome = true
      try {
        const res = await this.$http.post(`${this.$store.state.api}occurrence_involved_outcomes`, {
          occurrence_involved_id: this.occurrenceInvolvedId,
          outcome_id: this.newOutcome.outcome_id,
          observation: this.newOutcome.observation || null,
        })
        const saved = res.data.data || res.data
        this.involvedOutcomes.push(saved)
        this.newOutcome = { outcome_id: null, observation: '' }
        this.showOutcomeModal = false
        this.$emit('outcome-saved')
        this.$message('Desfecho registrado', 'Desfecho salvo com sucesso.', 'success')
      } catch (e) {
        this.$message('Erro', 'Erro ao registrar desfecho.', 'error')
      } finally {
        this.savingOutcome = false
      }
    },
    async cancelOutcome(id) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'O desfecho ficará marcado como cancelado e será mantido no histórico. Deseja continuar?',
        {
          title: 'Cancelar desfecho', okTitle: 'Sim, cancelar', cancelTitle: 'Voltar', okVariant: 'danger', centered: true, size: 'sm',
        },
      )
      if (!confirmed) return
      try {
        const res = await this.$http.delete(`${this.$store.state.api}occurrence_involved_outcomes/${id}`)
        const updated = res.data.data || res.data
        const idx = this.involvedOutcomes.findIndex(o => o.id === id)
        if (idx !== -1) this.$set(this.involvedOutcomes, idx, updated)
      } catch (e) {
        this.$message('Erro', 'Erro ao cancelar desfecho.', 'error')
      }
    },
  },
}
</script>
